import { DriverStatus, PosTerminalStatus, RequestAction, TransactionType } from 'enums';
import CustomerStatus from 'enums/driver-status';
import ProductCmms from 'enums/products-cmms';
import Route from 'enums/route';
import UserRole from 'enums/user-role';
import locale from 'localization';

export const prettifyCustomerStatus = (customerStatus) => {
  return (
    {
      [CustomerStatus.Active]: locale.active,
      [CustomerStatus.Inactive]: locale.inactive,
      [CustomerStatus.Terminated]: 'Terminated',
      [CustomerStatus.Delinquent]: 'Delinquent',
      [CustomerStatus.Pending]: 'Pending',
      [CustomerStatus.Claimed]: 'Claimed',
      [CustomerStatus.Rejected]: 'Rejected'
    }[customerStatus] || ''
  );
};

export const prettifyVehicleStatus = (vehicleStatus) => {
  return (
    {
      [DriverStatus.Active]: locale.active,
      [DriverStatus.Inactive]: locale.inactive
    }[vehicleStatus] || ''
  );
};

export const prettifyPosTerminalStatus = (status) => {
  return (
    {
      [PosTerminalStatus.Available]: 'Available',
      [PosTerminalStatus.InUse]: 'In-used',
      [PosTerminalStatus.Inactive]: locale.inactive
    }[status] || ''
  );
};

export const prettifyUserRole = (role) => {
  return (
    {
      [UserRole.Admin]: 'Admin',
      [UserRole.Maker]: 'Maker',
      [UserRole.SuperAdmin]: 'Super Admin',
      [UserRole.Approver]: 'Approver'
    }[role] || ''
  );
};

export const prettifyRequestAction = (action) => {
  return (
    {
      [RequestAction.TransferSavings]: 'Transfer to Savings',
      [RequestAction.Voiding]: 'Voiding',
      [RequestAction.Withdrawal]: 'Withdrawal'
    }[action] || ''
  );
};

export const prettifyTransactionType = (type) => {
  return (
    {
      [TransactionType.Regular]: 'Regular',
      [TransactionType.Member]: 'Member',
      [TransactionType.SeniorCitizen]: 'SC/S/PWD'
    }[type] || ''
  );
};

export const prettifyRoute = (route) => {
  return (
    {
      [Route.Lucban_Lucena]: 'Lucban - Lucena',
      [Route.Lucena_Lucban]: 'Lucena - Lucban',
      [Route.Tayabas_Mauban]: 'Tayabas - Mauban',
      [Route.Mauban_Tayabas]: 'Mauban - Tayabas'
    }[route] || ''
  );
};

export const prettifyProduct = (product) => {
  return (
    {
      [ProductCmms.SharedCapital]: 'Shared Capital',
      [ProductCmms.FixedDeposit]: 'Fixed Deposit',
      [ProductCmms.Savings]: 'Savings'
    }[product] || ''
  );
};
